module.exports = __webpack_public_path__ + "static/media/mockup-carteirinha-light.15f9cec7.png";